import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';


@Component({
  selector: 'beh-share-content-dialog',
  imports: [],
  templateUrl: './share-content-dialog.component.html',
  styleUrl: './share-content-dialog.component.scss'
})
export class ShareContentDialogComponent {
  private bottomSheetRef = inject<MatBottomSheetRef<ShareContentDialogComponent>>(MatBottomSheetRef);

  download() {
    this.bottomSheetRef.dismiss('download');
  }
  

  copyLink() {
    this.bottomSheetRef.dismiss('copy');
  }
}
